
export default {
  isInteger(e) {
    if (!e) {
      throw new Error('helper.isInteger: Event not found.');
    }
    const charCode = (e.which) ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      e.preventDefault();
      return false;
    }
    return true;
  },
  isFloat(e) {
    if (!e) {
      throw new Error('helper.isFloat: Event not found.');
    }
    const charCode = (e.which) ? e.which : e.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57) && (charCode !== 44 && charCode !== 46)) { // ascii . = 46
      e.preventDefault();
    }

    let precision;
    if (e.target.value.includes('.')) {
      precision = e.target.value.split('.').pop();
    } else if (e.target.value.includes(',')) {
      precision = e.target.value.split(',').pop();
    }
    if (precision && precision.length >= 2) {
      e.preventDefault();
    }

    return true;
  },
  formatNumber(number) {
    return number
      .toString()
      .replace(/ /g, '')
      .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  },
};
